export const HTTP_STATUS = {
  // Success (2xx)
  OK: 200,
  CREATED: 201,
  ACCEPTED: 202,
  NO_CONTENT: 204,

  // Client Errors (4xx)
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,        // Не авторизован (требуется аутентификация) просрочен токен
  FORBIDDEN: 403,           // Нет доступа (недостаточно прав)
  NOT_FOUND: 404,
  METHOD_NOT_ALLOWED: 405,
  CONFLICT: 409,
  UNPROCESSABLE_ENTITY: 422,
  TOO_MANY_REQUESTS: 429,

  // Server Errors (5xx)
  INTERNAL_SERVER_ERROR: 500,
  NOT_IMPLEMENTED: 501,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503
}

export const ERROR_MSG_HTTP_STATUS = {
  [HTTP_STATUS.BAD_REQUEST]: "400 Некорректный запрос. Проверьте введенные данные.",
  [HTTP_STATUS.UNAUTHORIZED]: "401 Не авторизован. Пожалуйста, выполните вход.",
  [HTTP_STATUS.FORBIDDEN]: "403 Нет доступа. Недостаточно прав.",
  [HTTP_STATUS.NOT_FOUND]: "404 Запрашиваемый ресурс не найден.",
  [HTTP_STATUS.METHOD_NOT_ALLOWED]: "405 Метод не поддерживается.",
  [HTTP_STATUS.CONFLICT]: "409 Конфликт данных. Такие данные уже есть или были изменены другим пользователем( Попробуйте обновить страницу).",
  [HTTP_STATUS.UNPROCESSABLE_ENTITY]: "422 Не удалось обработать запрос.",
  [HTTP_STATUS.TOO_MANY_REQUESTS]: "429 Слишком много запросов. Попробуйте позже.",

  [HTTP_STATUS.INTERNAL_SERVER_ERROR]: "500 Внутренняя ошибка сервера. Попробуйте позже.",
  [HTTP_STATUS.NOT_IMPLEMENTED]: "501 Функционал временно недоступен",
  [HTTP_STATUS.BAD_GATEWAY]: "502 Ошибка шлюза. Попробуйте позже",
  [HTTP_STATUS.SERVICE_UNAVAILABLE]: "503 Сервис временно недоступен. Попробуйте позже"
}
export const getErrorMessage = (status, defaultMessage = "Произошла неизвестная ошибка") => {
  return ERROR_MSG_HTTP_STATUS[status] || null;
}

export const ERROR_MSG_NETWORK_STATUS = {
  ECONNREFUSED: 'Сервер недоступен. Проверьте, запущен ли сервер и правильность адреса',
  ECONNRESET: 'Соединение с сервером было разорвано',
  ETIMEDOUT: 'Превышено время ожидания ответа от сервера',
  ENOTFOUND: 'Сервер не найден. Проверьте адрес сервера',
  NETWORK_ERROR: 'Проблема с интернет-соединением',
  FAILED_TO_FETCH: 'Не удалось установить соединение с сервером'
};
export const getNetworkErrorMessage = (code, defaultMessage = "Ошибка подключения к серверу") => {
  return ERROR_MSG_NETWORK_STATUS[code] || null;
};